import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import KanbanBoard from '../components/kanban/KanbanBoard';
import LeadModal from '../components/leads/LeadModal';
import Modal from '../components/common/Modal';
import { getLeads } from '../utils/api';
import '../styles/App.css';
import '../styles/kanban.css';

function Pipeline() {
  const [leads, setLeads] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ isOpen: false, title: '', message: '', type: 'info' });
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    loadLeads();
  }, []);

  const loadLeads = async () => {
    setLoading(true);
    try {
      const data = await getLeads({ bustCache: true });
      setLeads(data.leads);
    } catch (error) {
      setModal({
        isOpen: true,
        title: 'Error',
        message: 'Failed to load leads: ' + error.message,
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // Filter to only interested leads from Instantly campaigns
  const pipelineLeads = leads.filter(
    lead => lead.interest_status === 'interested' && Boolean(lead.campaign_name)
  );

  const handleLeadClick = (lead) => setSelectedLead(lead);
  const handleCloseModal = () => setSelectedLead(null);

  const handleLeadUpdate = (updatedLead, action = 'update', leadId = null) => {
    if (action === 'delete' && leadId) {
      setLeads(prev => prev.filter(lead => lead._id !== leadId));
      setSelectedLead(null);
    } else if (updatedLead) {
      setLeads(prev =>
        prev.map(lead => lead._id === updatedLead._id ? updatedLead : lead)
      );
      setSelectedLead(prev => prev && prev._id === updatedLead._id ? updatedLead : prev);
    }
  };

  if (loading) {
    return (
      <div className="app-container">
        <Header onMenuClick={toggleSidebar} />
        <div className="app-body">
          <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
          <main className="app-main">
            <div className="loading">Loading pipeline...</div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <Header onMenuClick={toggleSidebar} />
      <div className="app-body">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <main className="app-main">
          <div className="page-header">
            <h1>Pipeline</h1>
            <div className="page-header-actions">
              <span style={{ color: '#6b7280', fontSize: '14px', marginRight: '12px' }}>
                {pipelineLeads.length} interested leads from Instantly
              </span>
              <button onClick={loadLeads} className="btn btn-secondary" disabled={loading}>
                {loading ? 'Loading...' : 'Refresh'}
              </button>
            </div>
          </div>

          <KanbanBoard
            leads={pipelineLeads}
            onCardClick={handleLeadClick}
            onLeadUpdate={handleLeadUpdate}
          />

          {selectedLead && (
            <LeadModal
              lead={selectedLead}
              onClose={handleCloseModal}
              onLeadUpdate={handleLeadUpdate}
            />
          )}

          <Modal
            isOpen={modal.isOpen}
            onClose={() => setModal({ ...modal, isOpen: false })}
            title={modal.title}
            message={modal.message}
            type={modal.type}
          />
        </main>
      </div>
    </div>
  );
}

export default Pipeline;
